import _ from 'lodash';

const generateUniqueId = () => +(new Date().getTime() + _.uniqueId());
export default generateUniqueId;
